/*
  Inquiry-form mailing-list opt-in (Ralph 2026-10-05).

  A Shopify contact form only emails the inquiry; it cannot also create a
  subscriber. So when the box is ticked we remember the email, let the inquiry
  submit untouched (Shopify's captcha owns that submit), and once the page
  comes back with ?contact_posted=true we post a separate Shopify customer
  form (email marketing consent) into a hidden frame. The Mailchimp app syncs
  those customers into the audience.

  The checkbox also travels with the inquiry as "Mailing list: Yes", so the
  request is in the email even if the background sign-up is ever blocked.
*/
(() => {
  const KEY = 'psOptin';
  const MAX_AGE = 30 * 60 * 1000;
  let store;
  try { store = window.sessionStorage; } catch (e) { return; }
  if (!store) return;

  // Footer sign-up: a nearest-showroom pick is required. The radios carry the
  // tags; this only blocks an empty submit and shows the reminder.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const loc = form.querySelector('[data-ps-loc]');
    if (!loc) return;
    if (!loc.querySelector('input:checked')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.classList.add('is-missing');
      const first = loc.querySelector('input');
      if (first) first.focus();
    }
  }, true);
  document.addEventListener('change', (event) => {
    const el = event.target;
    if (el && el.closest && el.closest('[data-ps-loc]')) {
      const form = el.closest('form');
      if (form) form.classList.remove('is-missing');
    }
  });

  // Capture phase, no preventDefault: runs before Shopify's captcha handler
  // and never changes how the inquiry itself is submitted.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const optin = form.querySelector('[data-ps-optin]');
    if (!optin) return;
    const box = optin.querySelector('input[type="checkbox"]');
    const email = form.elements['contact[email]'];
    if (box && box.checked && email && email.value.trim()) {
      // The form's own "Which showroom?" answer becomes the location tag.
      const showroom = form.elements['contact[Showroom]'];
      const pick = showroom ? String(showroom.value) : '';
      const loc = /palm|fl\b/i.test(pick) ? 'showroom-fl' : (/ocean|nj\b/i.test(pick) ? 'showroom-nj' : '');
      store.setItem(KEY, JSON.stringify({
        email: email.value.trim(),
        source: optin.dataset.source || 'inquiry',
        loc: loc,
        at: Date.now()
      }));
    } else {
      store.removeItem(KEY);
    }
  }, true);

  function subscribe() {
    if (!/[?&]contact_posted=true/.test(window.location.search)) return;
    let data;
    try { data = JSON.parse(store.getItem(KEY) || 'null'); } catch (e) { data = null; }
    store.removeItem(KEY);
    if (!data || !data.email || Date.now() - data.at > MAX_AGE) return;

    const frame = document.createElement('iframe');
    frame.name = 'ps-optin-frame';
    frame.title = 'Mailing list sign-up';
    frame.hidden = true;
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;

    const form = document.createElement('form');
    form.method = 'post';
    form.action = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'contact';
    form.target = frame.name;
    form.hidden = true;
    const fields = {
      form_type: 'customer',
      utf8: '\u2713',
      'contact[email]': data.email,
      'contact[tags]': 'newsletter,' + data.source + (data.loc ? ',' + data.loc : '')
    };
    Object.keys(fields).forEach((name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.append(frame, form);
    const send = () => (form.requestSubmit ? form.requestSubmit() : form.submit());
    const captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, send);
    } else {
      send();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subscribe);
  } else {
    subscribe();
  }
})();
